const ICON_FULL_MODE = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" {...props}>
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.5}
      d="M2.414.25h5.172A2.16 2.16 0 0 1 9.75 2.414v5.172A2.16 2.16 0 0 1 7.586 9.75H2.414A2.16 2.16 0 0 1 .25 7.586V2.414A2.16 2.16 0 0 1 2.414.25z"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.5}
      d="M5.598 2.29h2.113v2.114M7.715 2.29l-5.42 5.42M4.407 7.715H2.295V5.601"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_FULL_MODE;
